export default {
    title: "Nástěnka",
    text_0: "Můj dashboard",
    text_1: "Hodnota nabídek tento měsíc",
    text_2: "Celková hodnota nabídek",
    text_3: "Počet klientů",
    text_4: "Počet Moje firmy",
    text_5: "Počet Položky a ceny",
    text_6: "Počet integrací SuperFaktura",
    text_7: "Počet uživatelů bez nabídky",
    text_8: "Počet uživatelů s 1 nabídkou",
    text_9: "Počet uživatelů s 2-5 nabídkami",
    text_10: "Počet uživatelů s více než 5 nabídkami",
    text_11: "Počet všech uživatelů",
    text_12: "Počet všech nabídek",
    text_13: "Počet všech klientů",
    text_14: "Počet tmavých nabídek",
    text_15: "Počet světlých nabídek",
    text_16: "Hodnota tvých nabídek",
    text_17: "Počet tvých nabídek",
    text_18: "Registrovaní uživatelé",
    text_19: "Počet všech nabídek",
    text_20: "TOP 10 uživatelů podle počtu nabídek",
    text_21: "Tvoje poslední nabídky",
    text_22: "Přejít na všechny nabídky",
    text_23: "Aktuálně nemáš vytvořeny žádné cenové nabídky. Nechceš nějakou vytvořit?",
    text_24: "Vytvořit nabídku",
    text_25: "Odeslané emaily",
    text_26: "Oblast podnikání",
    text_27: "Zdroj kontaktů",
    text_28: "Průměrná hodnota všech nabídek",
    text_29: "TOP 10 uživatelů podle celkové ceny nabídek",
    text_30: "TOP 10 uživatelů podle průměrné ceny nabídek",
    text_31: "Stavy cenových nabídek",

    // Tour buttons
    tour_start:  "Spustit prohlídku",
    tour_stop:   "Ukončit prohlídku",
    tour_back:   "Zpět",
    tour_next:   "Pokračovat",
    tour_finish: "Dokončit prohlídku",
    tour_skip:   "Přeskočit prohlídku",

    // Tour step content
    tour_s0_title: "Ahoj, vítej v DOFFERO!",
    tour_s0_text:  "V krátkosti ti ukážu, kde se co nachází.",
    tour_s1_title: "Důležitá čísla a statistiky",
    tour_s1_text:  "V této části uvidíš vytažená důležitá čísla ohledně tvých cenových nabídek. Pokud chceš vidět více dat, navštiv sekci Statistiky.",
    tour_s2_title: "Vytvořili jsme ti první nabídku",
    tour_s2_text:  "Vytvořili jsme pro tebe první testovací nabídku, abys viděl/a, jak může vypadat a jaké má možnosti.",
    tour_s3_title: "Otevři svou nabídku",
    tour_s3_text:  "Kliknutím na toto tlačítko otevřeš svou nabídku jako online odkaz, který můžeš poslat klientovi.",
    tour_s4_title: "Stav nabídky",
    tour_s4_text:  "Tato kulička reprezentuje stav tvé nabídky. Pokud svítí zeleně, nabídka je aktivní a veřejná. Pokud je žlutá, je ve stavu konceptu. Pokud vidíš červenou, znamená to, že nabídka je neaktivní.",
    tour_s5_title: "Uprav svou nabídku",
    tour_s5_text:  "Kliknutím na toto tlačítko se dostaneš do módu editace nabídky a můžeš ji upravovat.",
    tour_s6_title: "Duplikuj svou nabídku",
    tour_s6_text:  "Kliknutím sem duplikuješ svou nabídku a snadno podle ní vytvoříš novou.",
    tour_s7_title: "Vytvoř novou nabídku",
    tour_s7_text:  "Když budeš chtít vytvořit novou cenovou nabídku, klikni na toto tlačítko.",
    tour_s8_title: "Správa klientů (CRM)",
    tour_s8_text:  "Spravuj své klienty na jednom místě. Přidej všechny potřebné údaje, nastav si zdroj, kde jsi klienta získal a dokonce si můžeš nastavit, abychom ti připomněli, že se máš ozvat klientovi.",
    tour_s9a_title: "Barevnost nabídek",
    tour_s9a_text:  "Nastav si barvy cenových nabídek podle svého brandingu.",
    tour_s9b_title: "Přidej recenze do nabídky",
    tour_s9b_text:  "Přidej si recenze svých klientů do cenové nabídky a zvyš šanci na úspěch.",
    tour_s9c_title: "Kolegové či zaměstnanci",
    tour_s9c_text:  "Přidej své kolegy či zaměstnance pod svůj účet a pracujte na nabídkách společně pod jednou firmou.",
    tour_s10a_title: "Databáze položek",
    tour_s10a_text:  "Připrav si databázi položek a jejich cen předem a pak je snadno používej při tvorbě nabídek.",
    tour_s10b_title: "Statistiky",
    tour_s10b_text:  "Na tomto místě najdeš detailní statistiky k svým nabídkám a klientům. Pokud máš přidané kolegy, také zde najdeš info k jejich výkonnosti.",
    tour_s11a_title: "Máš více firem?",
    tour_s11a_text:  "Pokud máš více firem, nemusíš si pro ně vytvářet nové účty. Vytvárej nabídky pod jedním účtem.",
    tour_s11b_title: "Dolaď si účet",
    tour_s11b_text:  "Prohlédni si možnosti nastavení a dolaď si co potřebuješ.",
};
